<template>
    <div :id="`pdf-context-menu-${pageNumber}`" class="pdf-context-menu" style="display: none;">
        <ul class="menu-options">
            <li class="menu-option">
                <a @click.prevent.stop="removeMultiple">
                    <i class="fas fa-times mr-3"></i> Remove Selected
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
    name: 'ContextMenuReorder',
    components: {},
    props: {
        pageNumber: {
            required: true,
        },
    },
    data() {
        return {}
    },
    computed: {},
    watch: {},
    mounted() {
    },
    updated() {
    },
    activated() {
    },
    methods: {
        removeMultiple(e) {
            e.stopPropagation();
            let indexs = [];
            const selected = $('.multi-drag .pdf-thumbnail').each(function () {
                let index = $(this).data('index');
                indexs.push(index);
            });

            this.$bus.$emit('pdf::pages::remove', indexs);
            this.indexs = [];
            this.hideContextMenu();
        },
        hideContextMenu() {
            $('[id^="pdf-context-menu-"]').hide();
            this.$bus.$emit("pdf::contextmenu::menuclose");
        }
    }
}
</script>

<style lang="scss" scoped>
.pdf-context-menu {
    min-width: 190px;
    position: absolute;
    z-index: 100;
    box-shadow: 0 7px 25px 1px rgba(0, 0, 0, 0.12);
    background: #202733;
    border-radius: 8px;
    overflow: hidden;

    .menu-options {
        list-style: none;
        width: 100%;
        margin: 0;
        padding: 0;

        .menu-option {
            a {
                width: 100%;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                white-space: nowrap;
                font-weight: 700;
                font-size: 0.9375em;
                padding: 15px 15px;
                cursor: pointer;
                width: 100%;
                color: #cadaed;
            }

            &:hover {
                a {
                    background: #2392ef;
                    color: #cadaed;
                }
            }
        }
    }
}
</style>
